/* =============================================
   Anatolian Bazaar — Ana Tema JavaScript
   ============================================= */

/* --- iOS Uyumlu Scroll Kilidi ---
   iOS Safari/Chrome'da overflow:hidden body'yi kilitlemez.
   Position:fixed trick ile düzeltiyoruz.
   ------------------------------------------------ */
let _scrollLockY = 0;

function lockBodyScroll() {
  _scrollLockY = window.scrollY || window.pageYOffset;
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + _scrollLockY + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.overflow = 'hidden';
}

function unlockBodyScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.overflow = '';
  window.scrollTo(0, _scrollLockY);
}

/* --- Arama Paneli --- */
let _searchTrigger = null;

function openSearch() {
  const overlay = document.getElementById('search-overlay');
  const backdrop = document.getElementById('search-backdrop');
  _searchTrigger = document.activeElement;
  overlay.classList.add('is-open');
  overlay.setAttribute('aria-hidden', 'false');
  backdrop.classList.add('is-visible');
  document.querySelectorAll('[data-action="open-search"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
  lockBodyScroll();
  setTimeout(() => {
    const input = overlay.querySelector('#search-input');
    if (input) input.focus();
  }, 300);
}

function closeSearch() {
  const overlay = document.getElementById('search-overlay');
  const backdrop = document.getElementById('search-backdrop');
  overlay.classList.remove('is-open');
  overlay.setAttribute('aria-hidden', 'true');
  backdrop.classList.remove('is-visible');
  document.querySelectorAll('[data-action="open-search"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  unlockBodyScroll();
  if (_searchTrigger) { _searchTrigger.focus(); _searchTrigger = null; }
}

/* --- Sepet Yan Paneli --- */
let _cartTrigger = null;

function openCart() {
  const drawer = document.getElementById('cart-drawer');
  _cartTrigger = document.activeElement;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.querySelectorAll('[data-action="open-cart"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
  lockBodyScroll();
  refreshCartDrawer();
  setTimeout(() => drawer.querySelector('.cart-drawer__close')?.focus(), 100);
}

function closeCart() {
  const drawer = document.getElementById('cart-drawer');
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.querySelectorAll('[data-action="open-cart"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  unlockBodyScroll();
  if (_cartTrigger) { _cartTrigger.focus(); _cartTrigger = null; }
}

async function refreshCartDrawer() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    renderCartDrawer(cart);
  } catch (e) {
    console.error('Sepet yüklenemedi:', e);
  }
}

/* --- Ücretsiz Kargo Progress Bar --- */
const FREE_SHIPPING_THRESHOLD = (window.freeShippingThreshold || 1000) * 100; // Kuruş cinsinden

function updateShippingBar(totalPrice) {
  // Sepet içindeki bar
  const textEl = document.getElementById('cart-shipping-bar-text');
  const fillEl = document.getElementById('cart-shipping-bar-fill');
  if (textEl && fillEl) {
    if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
      textEl.innerHTML = '🎉 Ücretsiz kargoya hak kazandınız!';
      fillEl.style.width = '100%';
      fillEl.style.background = 'var(--color-secondary)';
    } else {
      const remaining = (FREE_SHIPPING_THRESHOLD - totalPrice) / 100;
      const remainingFmt = remaining.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const progress = Math.min((totalPrice / FREE_SHIPPING_THRESHOLD) * 100, 100);
      textEl.innerHTML = '<b>' + remainingFmt + ' TL</b> daha ekle, ücretsiz kargo!';
      fillEl.style.width = progress + '%';
      fillEl.style.background = 'var(--color-primary)';
    }
  }

  // Announcement bar'daki bar
  updateAnnouncementBar(totalPrice);
}

function updateAnnouncementBar(totalPrice) {
  const barEl = document.getElementById('announcement-shipping-bar');
  const barTextEl = document.getElementById('announcement-shipping-text');
  const barFillEl = document.getElementById('announcement-shipping-fill');
  if (!barEl) return;

  // Bar her zaman görünür
  barEl.style.display = 'block';

  if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
    if (barTextEl) barTextEl.innerHTML = '🎉 Ücretsiz kargoya hak kazandınız!';
    if (barFillEl) {
      barFillEl.style.width = '100%';
      barFillEl.style.background = 'rgba(255,255,255,0.9)';
    }
  } else {
    const remaining = (FREE_SHIPPING_THRESHOLD - totalPrice) / 100;
    const remainingFmt = remaining.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const progress = Math.round((totalPrice / FREE_SHIPPING_THRESHOLD) * 100);
    if (barTextEl) barTextEl.innerHTML = '🚚 <b>' + remainingFmt + ' TL</b> daha ekle, ücretsiz kargo!';
    if (barFillEl) {
      barFillEl.style.width = progress + '%';
      barFillEl.style.background = '';
    }
  }
}

function renderCartDrawer(cart) {
  const itemsEl = document.getElementById('cart-drawer-items');
  const totalEl = document.getElementById('cart-drawer-total');

  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = `
      <div class="cart-empty">
        <svg class="cart-empty__icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 8h14l-1.1 11.1a2 2 0 0 1-2 1.8H8.1a2 2 0 0 1-2-1.8L5 8z"/>
          <path d="M8.6 8V6.2a3.4 3.4 0 0 1 6.8 0V8"/>
        </svg>
        <p>Sepetiniz boş</p>
      </div>
    `;
    if (totalEl) totalEl.textContent = formatMoney(0);
    updateShippingBar(0); // Sepet boşaldığında barı sıfırla
    return;
  }

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${escHtml(item.key)}">
      <div class="cart-item__image">
        <img src="${item.image ? item.image.replace('http:', 'https:') : ''}" alt="${escHtml(item.title)}" loading="lazy">
      </div>
      <div class="cart-item__info">
        <div class="cart-item__title">${escHtml(item.product_title)}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${escHtml(item.variant_title)}</div>` : ''}
        <div class="cart-item__price">${formatMoney(item.price)}</div>
        <div class="cart-item__qty">
          <button data-action="cart-qty" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="${item.product_title} miktarını azalt">−</button>
          <span aria-label="Adet: ${item.quantity}">${item.quantity}</span>
          <button data-action="cart-qty" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="${item.product_title} miktarını artır">+</button>
        </div>
      </div>
    </div>
  `).join('');

  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  updateShippingBar(cart.total_price);
}

async function updateCartItem(key, quantity) {
  try {
    const response = await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await response.json();
    renderCartDrawer(cart);
    updateCartCount(cart.item_count);
  } catch (e) {
    console.error('Güncelleme hatası:', e);
  }
}
/* Buton etiketini ikonu silmeden degistirir.
   Kart butonlarinda metin bir <span> icindedir; ikon yerinde kalir.
   Span yoksa (urun sayfasi butonu gibi) eski davranisa duser. */
function setButtonLabel(buttonEl, text) {
  if (!buttonEl) return;
  const span = buttonEl.querySelector('span');
  if (span) span.textContent = text;
  else buttonEl.textContent = text;
}

function getButtonLabel(buttonEl) {
  if (!buttonEl) return '';
  const span = buttonEl.querySelector('span');
  return (span ? span.textContent : buttonEl.textContent).trim();
}


async function addToCart(variantId, quantity = 1, buttonEl = null) {
  // Buton yükleniyor durumu
  if (buttonEl) {
    buttonEl.disabled = true;
    const originalText = getButtonLabel(buttonEl);
    buttonEl.dataset.originalText = originalText;
    setButtonLabel(buttonEl, 'Ekleniyor...');
  }

  try {
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    const result = await response.json();

    if (result.status === 422) {
      alert(result.description || window.cartStrings.error);
      if (buttonEl) {
        buttonEl.disabled = false;
        setButtonLabel(buttonEl, buttonEl.dataset.originalText || 'Sepete Ekle');
      }
      return;
    }

    // Başarı — butonu yeşil yap, yazıyı değiştir
    if (buttonEl) {
      buttonEl.classList.add('is-added');
      setButtonLabel(buttonEl, 'Sepete Eklendi');
      setTimeout(() => {
        buttonEl.classList.remove('is-added');
        setButtonLabel(buttonEl, buttonEl.dataset.originalText || 'Sepete Ekle');
        buttonEl.disabled = false;
      }, 2000);
    }

    const currentCount = parseInt(document.querySelector('.cart-count')?.textContent || '0', 10);
    updateCartCount(currentCount + quantity);

    // Sepet sayısını ve kargo barını güncelle, ama sepeti otomatik açma
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        updateAnnouncementBar(cart.total_price);
      })
      .catch(() => {});
  } catch (e) {
    console.error('Sepete ekleme hatası:', e);
    if (buttonEl) {
      buttonEl.disabled = false;
      setButtonLabel(buttonEl, buttonEl.dataset.originalText || 'Sepete Ekle');
    }
  }
}

function updateCartCount(count) {
  const countEls = document.querySelectorAll('.cart-count');
  countEls.forEach(el => {
    el.textContent = count;
    el.classList.toggle('is-hidden', count <= 0);
  });
}

function escHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function formatMoney(cents) {
  const amount = (cents / 100).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return amount + ' TL';
}

/* --- Mobil Menü --- */
let _menuTrigger = null;

function openMobileMenu() {
  const nav = document.getElementById('mobile-nav');
  if (!nav) return;
  _menuTrigger = document.activeElement;
  nav.style.display = 'flex';
  nav.setAttribute('aria-hidden', 'false');
  document.querySelectorAll('[data-action="open-mobile-menu"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
  requestAnimationFrame(() => nav.classList.add('is-open'));
  lockBodyScroll();

  /* Panel her açılışta en üstten başlasın; sticky başlık altındaki
     ayırıcı çizgi yalnızca kaydırıldığında görünsün. */
  const panel = nav.querySelector('.mobile-nav__panel');
  if (panel) {
    panel.scrollTop = 0;
    panel.classList.remove('is-scrolled');
    if (!panel.dataset.scrollBound) {
      panel.addEventListener('scroll', () => {
        panel.classList.toggle('is-scrolled', panel.scrollTop > 4);
      }, { passive: true });
      panel.dataset.scrollBound = '1';
    }
  }

  setTimeout(() => nav.querySelector('.mobile-nav__close-btn')?.focus(), 350);
}

function closeMobileMenu() {
  const nav = document.getElementById('mobile-nav');
  if (!nav) return;
  nav.classList.remove('is-open');
  nav.setAttribute('aria-hidden', 'true');
  document.querySelectorAll('[data-action="open-mobile-menu"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  unlockBodyScroll();
  setTimeout(() => { nav.style.display = 'none'; }, 350);
  if (_menuTrigger) { _menuTrigger.focus(); _menuTrigger = null; }
}

/* Mobil nav: panel dışına tıklanınca kapat */
function handleMobileNavClick(event) {
  const panel = event.currentTarget.querySelector('.mobile-nav__panel');
  if (panel && !panel.contains(event.target)) {
    closeMobileMenu();
  }
}

/* =============================================
   Merkezi Data-Action Delegated Listener
   Tüm onclick="" kullanımlarının yerini alır.
   ============================================= */
document.addEventListener('click', function (e) {
  const actionEl = e.target.closest('[data-action]');
  if (!actionEl) return;

  switch (actionEl.dataset.action) {
    case 'open-search':       openSearch();       break;
    case 'close-search':      closeSearch();      break;
    case 'open-cart':         openCart();         break;
    case 'close-cart':        closeCart();        break;
    case 'open-mobile-menu':  openMobileMenu();   break;
    case 'close-mobile-menu': closeMobileMenu();  break;
    case 'cart-qty': {
      const key = actionEl.dataset.key;
      const qty = parseInt(actionEl.dataset.qty, 10);
      if (key !== undefined && !isNaN(qty)) updateCartItem(key, qty);
      break;
    }

    case 'qty-change': {
      const delta = parseInt(actionEl.dataset.delta, 10);
      const qtyInput = document.getElementById('product-qty-input');
      if (qtyInput && !isNaN(delta)) {
        const current = parseInt(qtyInput.value) || 1;
        const min = parseInt(qtyInput.min) || 1;
        const max = parseInt(qtyInput.max) || 99;
        qtyInput.value = Math.min(Math.max(current + delta, min), max);
      }
      break;
    }

    case 'switch-image': {
      const imgSrc = actionEl.dataset.imgSrc;
      const imgAlt = actionEl.dataset.imgAlt;
      const mainImg = document.getElementById('product-main-image');
      if (mainImg && imgSrc) {
        mainImg.src = imgSrc;
        if (imgAlt) mainImg.alt = imgAlt;
      }
      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('product-gallery__thumb--active'));
      actionEl.classList.add('product-gallery__thumb--active');
      break;
    }
  }
});

/* --- Ürün Sayfası Variant Seçici (radio change) --- */
document.addEventListener('change', function(e) {
  const input = e.target;
  if (input.type !== 'radio' || input.dataset.action !== 'variant-change') return;

  const optionIndex = parseInt(input.dataset.optionIndex, 10);

  // Seçilen değeri etiket spanında güncelle
  const valueSpan = document.getElementById('option-value-' + (optionIndex + 1));
  if (valueSpan) valueSpan.textContent = input.value;

  // is-selected sınıfını güncelle
  const group = input.closest('.product-option-group');
  if (group) {
    group.querySelectorAll('.variant-option-label').forEach(function(lbl) { lbl.classList.remove('is-selected'); });
    const lbl = input.nextElementSibling;
    if (lbl) lbl.classList.add('is-selected');
  }

  // Tüm seçili option değerlerini topla
  const allGroups = document.querySelectorAll('.product-option-group');
  const selections = [];
  allGroups.forEach(function(g) {
    const checked = g.querySelector('input[type="radio"]:checked');
    selections.push(checked ? checked.value : null);
  });

  // Variants JSON'dan eşleşen varyantı bul
  const variantsEl = document.getElementById('product-variants-json');
  if (!variantsEl) return;
  var variantsData;
  try { variantsData = JSON.parse(variantsEl.textContent); } catch(err) { return; }

  const matched = variantsData.variants.find(function(v) {
    const opts = [v.option1, v.option2, v.option3];
    return selections.every(function(sel, i) { return sel == null || opts[i] === sel; });
  });
  if (!matched) return;

  // Sepet butonunu güncelle
  const addBtn = document.querySelector('[data-add-to-cart]');
  if (addBtn) {
    addBtn.dataset.variantId = matched.id;
    addBtn.disabled = !matched.available;
    addBtn.textContent = matched.available ? 'Sepete Ekle' : 'Stok Yok';
  }

  // Fiyatı güncelle
  const priceEl = document.getElementById('product-price');
  if (priceEl) priceEl.textContent = formatMoney(matched.price);

  const compareEl = document.getElementById('product-compare-price');
  const discountEl = document.getElementById('product-discount');
  if (compareEl) {
    if (matched.compare_at_price > matched.price) {
      compareEl.textContent = formatMoney(matched.compare_at_price);
      compareEl.style.display = '';
      if (discountEl) {
        const disc = Math.round((matched.compare_at_price - matched.price) * 100 / matched.compare_at_price);
        discountEl.textContent = '-%' + disc;
        discountEl.style.display = '';
      }
    } else {
      compareEl.style.display = 'none';
      if (discountEl) discountEl.style.display = 'none';
    }
  }
});


/* --- Sayfa Kaydırılınca Header Gölgesi --- */
window.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (header) {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }
}, { passive: true });

// Resize debounce — gereksiz çağrıları engeller
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(updateMainPadding, 100);
}, { passive: true });

/* --- Klavye Kısayolları (Escape İle Panelleri Kapat) --- */
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeSearch();
    closeCart();
    closeMobileMenu();
  }
});

/* --- Bildirim Şeridi + Header Konumunu Ve Sayfa Boşluğunu Ayarla ---
   Bildirim şeridi top:0'a sabitlenir.
   Header, bildirim şeridinin hemen altına konumlandırılır.
   Ana içerik her ikisinin toplam yüksekliği kadar aşağı itilir.
   ------------------------------------------------------------------ */
function updateMainPadding() {
  const announcementSection = document.getElementById('shopify-section-announcement-bar');
  const headerSection = document.getElementById('shopify-section-header');
  const main = document.getElementById('main-content');

  const announcementHeight = announcementSection ? announcementSection.offsetHeight : 0;

  // Header'ı bildirim şeridinin hemen altına taşı
  if (headerSection) {
    headerSection.style.top = announcementHeight + 'px';
    // Ana içeriği her ikisinin toplamı kadar aşağı it
    if (main) {
      main.style.paddingTop = (announcementHeight + headerSection.offsetHeight) + 'px';
    }
  } else if (main) {
    main.style.paddingTop = announcementHeight + 'px';
  }
}

/* =============================================
   KVKK Çerez Bildirimi + Analitik Consent
   ============================================= */

/**
 * type="text/plain" data-analytics-src="..." ile işaretlenmiş
 * tüm opsiyonel scriptleri dinamik olarak yükler.
 * Yalnızca kullanıcı "Kabul Et" dediğinde çağrılır.
 */
function loadAnalytics() {
  document.querySelectorAll('script[type="text/plain"][data-analytics-src]').forEach(placeholder => {
    const script = document.createElement('script');
    script.src = placeholder.dataset.analyticsSrc;
    script.async = true;
    if (placeholder.id) script.id = placeholder.id + '-loaded';
    document.head.appendChild(script);
  });
}

function initKvkk() {
  const banner = document.getElementById('kvkk-banner');
  if (!banner) return;

  const choice = localStorage.getItem('kvkk_choice');

  if (choice === 'accepted') {
    // Daha önce kabul etti — analitikleri yükle, banner'ı kaldır
    loadAnalytics();
    banner.remove();
    return;
  }
  if (choice === 'rejected') {
    // Daha önce reddetti — analitik YÜKLENMEDİ, banner kaldır
    banner.remove();
    return;
  }

  // İlk ziyaret — seçim yok, banner'ı göster
  banner.style.display = '';

  banner.querySelector('#kvkk-accept').addEventListener('click', () => {
    localStorage.setItem('kvkk_choice', 'accepted');
    loadAnalytics(); // ← Kabul: analitikler şimdi yükleniyor
    dismissKvkk(banner);
  });

  banner.querySelector('#kvkk-reject').addEventListener('click', () => {
    localStorage.setItem('kvkk_choice', 'rejected');
    // loadAnalytics() ÇAĞRILMAZ — opsiyonel scriptler hiç yüklenmez
    dismissKvkk(banner);
  });
}

function dismissKvkk(banner) {
  banner.classList.add('is-hiding');
  setTimeout(() => banner.remove(), 320);
}

/* =============================================
   Son Gezilen Ürünler (Recently Viewed)
   ============================================= */
function initRecentlyViewed() {
  const dataEl = document.getElementById('product-json-data');
  if (!dataEl) return;

  let current;
  try { current = JSON.parse(dataEl.textContent); } catch(e) { return; }

  // Listeyi oku
  let viewed = [];
  try { viewed = JSON.parse(localStorage.getItem('ab_recently_viewed') || '[]'); } catch(e) {}

  // Mevcut ürünü listeden çıkar, başa ekle
  viewed = viewed.filter(p => p.id !== current.id);
  viewed.unshift(current);
  if (viewed.length > 12) viewed = viewed.slice(0, 12);
  localStorage.setItem('ab_recently_viewed', JSON.stringify(viewed));

  // Mevcut ürün hariç, max 5 ürün göster
  const toShow = viewed.filter(p => p.id !== current.id).slice(0, 5);
  if (!toShow.length) return;

  const section = document.getElementById('recently-viewed-section');
  const grid = document.getElementById('recently-viewed-grid');
  if (!section || !grid) return;

  grid.innerHTML = toShow.map(p => {
    const price = formatMoney(p.price_raw);
    const vendor = p.vendor ? `<div class="product-card__brand">${p.vendor}</div>` : '';
    const onSale = p.compare_price_raw && p.compare_price_raw > p.price_raw;
    const discountPct = onSale ? Math.round((p.compare_price_raw - p.price_raw) * 100 / p.compare_price_raw) : 0;
    const badge = !p.available
      ? `<span class="product-card__badge product-card__badge--sold-out">Tükendi</span>`
      : onSale ? `<span class="product-card__badge product-card__badge--sale">-%${discountPct}</span>` : '';
    /* İndirim yüzdesi zaten sol üstteki rozette gösteriliyor;
       fiyatın altında ikinci kez tekrarlanmıyor. */
    const priceCompare = onSale
      ? `<span class="price--compare">${formatMoney(p.compare_price_raw)}</span>`
      : '';
    const addBtn = p.available && p.variant_id
      ? `<button class="product-card__add-btn" data-add-to-cart data-variant-id="${p.variant_id}" aria-label="${p.title} sepete ekle">Sepete Ekle</button>`
      : `<button class="product-card__add-btn" disabled>Stok Yok</button>`;
    return `
      <div class="product-card">
        <a href="${p.url}" class="product-card__link" aria-label="${p.title}">
          <div class="product-card__image-wrap">
            ${badge}
            <img src="${p.image}" alt="${p.title}" loading="lazy">
          </div>
          <div class="product-card__body">
            ${vendor}
            <h3 class="product-card__title">${p.title}</h3>
            <div class="product-card__price">
              <span class="price">${price}</span>
              ${priceCompare}
            </div>
          </div>
        </a>
        ${addBtn}
      </div>`;
  }).join('');

  section.style.display = 'block';
}

/* =============================================
   Scroll Reveal Animasyonları (Soft)
   ============================================= */
function initScrollReveal() {
  if (!('IntersectionObserver' in window)) return;

  const targets = document.querySelectorAll(
    '.section-title, .trust-badge, .category-icon-item, .product-card'
  );
  if (!targets.length) return;

  targets.forEach(el => {
    el.classList.add('reveal');
    // Ürün kartlarının sırası CSS'te satır başına sıfırlanarak verilir;
    // burada gecikme atarsak uzun listelerde son kartlar geç kalır.
    if (el.classList.contains('product-card')) return;
    // Grid içindeki öğelere hafif stagger
    const grid = el.closest('.trust-badges__grid, .category-icons__grid');
    if (grid) {
      const siblings = Array.from(grid.children);
      const idx = siblings.indexOf(el);
      if (idx > 0) el.style.transitionDelay = `${idx * 0.07}s`;
    }
  });

  const obs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  targets.forEach(el => obs.observe(el));

  // Emniyet: gözlemci herhangi bir sebeple çalışmazsa (arka plan sekmesi,
  // eklenti engeli, hata) içerik görünmez kalmasın. 2.5 sn sonra ne varsa
  // görünür işaretlenir; normal akışta bu satır hiçbir şeyi değiştirmez.
  setTimeout(() => {
    document.querySelectorAll('.reveal:not(.is-visible)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-visible');
    });
  }, 2500);
}

/* Sayfa gizliyken (arka plan sekmesi) IntersectionObserver tetiklenmeyebilir.
   Sekme öne geldiğinde görünür alandaki öğeleri hemen açığa çıkarırız. */
document.addEventListener('visibilitychange', () => {
  if (document.hidden) return;
  document.querySelectorAll('.reveal:not(.is-visible)').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
  });
});

/* --- Sayfa Yüklendiğinde Çalışanlar --- */
document.addEventListener('DOMContentLoaded', () => {
  // Header yüksekliğine göre sayfa padding'ini ayarla
  updateMainPadding();

  // Mobil menü backdrop tıklaması (panel dışı)
  const mobileNav = document.getElementById('mobile-nav');
  if (mobileNav) {
    mobileNav.addEventListener('click', handleMobileNavClick);
  }

  // Sepet sayısını başlat + announcement bar'ı güncelle
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      updateAnnouncementBar(cart.total_price);
    })
    .catch(() => {});

  // Yeni özellikler
  initKvkk();
  initRecentlyViewed();
  initScrollReveal();

  // Sepete ekle — event delegation ile hem statik hem JS-render kartlar çalışır
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const qtyInput = document.getElementById('product-qty-input');
    const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value) || 1) : 1;
    addToCart(variantId, quantity, btn);
  });
});

/* =============================================
   Bölüm Beliriş Animasyonu
   Yeni bölümler (marka hikayesi, adımlar, SSS, spotlight)
   ekrana girdiğinde yumuşakça belirir.
   ============================================= */
function initSectionReveal() {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll(
    '.brand-story__inner, .howto__steps, .faq__list, .spotlight__inner'
  );
  if (!targets.length) return;

  targets.forEach(function (el) { el.classList.add('section-reveal'); });

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function (el) { obs.observe(el); });
}

document.addEventListener('DOMContentLoaded', initSectionReveal);

/* =============================================
   Canlı Arama (Predictive Search)
   Shopify /search/suggest.json ile yazarken sonuç gösterir.
   Klavye ile gezinme ve ekran okuyucu bildirimi destekli.
   ============================================= */
function initPredictiveSearch() {
  var input = document.getElementById('search-input');
  var results = document.getElementById('search-results');
  if (!input || !results) return;

  var timer = null;
  var lastQuery = '';
  var controller = null;

  function clearResults(message) {
    results.innerHTML = message ? '<p class="search-results__empty">' + message + '</p>' : '';
    results.classList.toggle('is-open', !!message);
  }

  /* suggest.json fiyati "10.00" metni olarak doner (kurus degil).
     Sayi gelirse kurus kabul edilir; her iki durumu da guvenle bicimler. */
  function money(value) {
    var num = typeof value === "number" ? value / 100 : parseFloat(String(value).replace(",", "."));
    if (isNaN(num)) return "";
    return num.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " TL";
  }

  function render(products, query) {
    if (!products.length) {
      clearResults('"' + query + '" için sonuç bulunamadı.');
      return;
    }

    var html = '<ul class="search-results__list" role="listbox" aria-label="Arama önerileri">';
    products.forEach(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
      html += '<li role="option" aria-selected="false"><a class="search-results__item" href="' + p.url + '">' +
        (img ? '<img class="search-results__img" src="' + img + '" alt="" loading="lazy">' : '<span class="search-results__img search-results__img--empty"></span>') +
        '<span class="search-results__text">' +
          '<span class="search-results__title">' + p.title + '</span>' +
          '<span class="search-results__price">' + money(p.price) + '</span>' +
        '</span></a></li>';
    });
    html += '</ul>';
    html += '<a class="search-results__all" href="/search?q=' + encodeURIComponent(query) + '&type=product">' +
      'Tüm sonuçları gör' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
      '</a>';

    results.innerHTML = html;
    results.classList.add('is-open');
  }

  function search(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products, query);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') clearResults('Arama şu anda yapılamıyor.');
      });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);

    if (q.length < 2) { clearResults(''); lastQuery = ''; return; }
    if (q === lastQuery) return;

    timer = setTimeout(function () {
      lastQuery = q;
      search(q);
    }, 250);
  });

  /* Overlay kapanınca sonuçları temizle */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="close-search"]')) clearResults('');
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') clearResults('');
  });
}

/* =============================================
   Ürün Paylaşımı
   Link kopyalama + WhatsApp / Facebook / X.
   Kopyalandığında kısa bir bildirim gösterir.
   ============================================= */
function initShare() {
  var copyBtn = document.querySelector('[data-share-copy]');
  if (!copyBtn) return;

  copyBtn.addEventListener('click', function () {
    var url = copyBtn.dataset.shareCopy || window.location.href;

    function done() {
      var original = copyBtn.getAttribute('aria-label');
      copyBtn.classList.add('is-copied');
      copyBtn.setAttribute('aria-label', 'Link kopyalandı');

      var toast = document.createElement('span');
      toast.className = 'share-toast';
      toast.setAttribute('role', 'status');
      toast.textContent = 'Link kopyalandı';
      copyBtn.parentNode.appendChild(toast);

      setTimeout(function () {
        copyBtn.classList.remove('is-copied');
        copyBtn.setAttribute('aria-label', original);
        toast.remove();
      }, 1800);
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(done).catch(fallback);
    } else {
      fallback();
    }

    function fallback() {
      var tmp = document.createElement('textarea');
      tmp.value = url;
      tmp.setAttribute('readonly', '');
      tmp.style.position = 'absolute';
      tmp.style.left = '-9999px';
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand('copy'); done(); } catch (e) { /* sessizce geç */ }
      document.body.removeChild(tmp);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initPredictiveSearch();
  initShare();
});

/* =============================================
   Judge.me — Türkçeleştirme
   Uygulama widget'ı İngilizce metinlerle geliyor. Buradaki sözlük,
   yalnızca TAM eşleşen etiket metinlerini ve yalnızca Judge.me
   kapsayıcılarının içindeki alt öğeleri değiştirir; yorum metinlerine
   veya kullanıcı içeriğine dokunmaz.

   Kalıcı çözüm Judge.me uygulamasının dil ayarıdır; bu katman
   o ayar yapılana kadar (ve yapılsa bile eksik kalan yerlerde) devrede.
   ============================================= */
(function () {
  var TR = {
    'Customer Reviews': 'Müşteri Yorumları',
    'Customer reviews': 'Müşteri Yorumları',
    'Reviews': 'Yorumlar',
    'Be the first to write a review': 'İlk yorumu siz yazın',
    'Write a review': 'Yorum Yaz',
    'Write a Review': 'Yorum Yaz',
    'Ask a question': 'Soru Sor',
    'Questions': 'Sorular',
    'Most Recent': 'En Yeni',
    'Newest': 'En Yeni',
    'Oldest': 'En Eski',
    'Highest Rating': 'En Yüksek Puan',
    'Lowest Rating': 'En Düşük Puan',
    'Most Helpful': 'En Faydalı',
    'Only Pictures': 'Sadece Görselli',
    'Pictures First': 'Önce Görselliler',
    'Videos First': 'Önce Videolular',
    'With Pictures': 'Görselli',
    'Verified Buyer': 'Doğrulanmış Alıcı',
    'Verified': 'Doğrulanmış',
    'Was this helpful?': 'Faydalı mıydı?',
    'Share': 'Paylaş',
    'Report as Inappropriate': 'Uygunsuz olarak bildir',
    'Submit Review': 'Yorumu Gönder',
    'Submit': 'Gönder',
    'Cancel': 'Vazgeç',
    'Name': 'Adınız',
    'Email': 'E-posta',
    'Rating': 'Puan',
    'Review Title': 'Yorum Başlığı',
    'Review': 'Yorumunuz',
    'Pictures/Video (optional)': 'Görsel / Video (isteğe bağlı)',
    'How would you rate this item?': 'Bu ürünü nasıl değerlendirirsiniz?',
    'Thank you!': 'Teşekkürler!',
    'Thank you! Your review is submitted.': 'Teşekkürler! Yorumunuz alındı.',
    'Load More': 'Daha Fazla Göster',
    'Previous': 'Önceki',
    'Next': 'Sonraki',
    'Sort': 'Sırala',
    'Product Reviews': 'Ürün Yorumları',
    'Shop Reviews': 'Mağaza Yorumları',
    'No reviews yet': 'Henüz yorum yok',
    'See all reviews': 'Tüm yorumları gör'
  };

  var SCOPES = '.jdgm-widget, .jdgm-rev-widg, .jdgm-form, .jdgm-prev-badge, .jdgm-all-reviews-widget, .jdgm-carousel';

  function translateIn(root) {
    var scopes = root.matches && root.matches(SCOPES) ? [root] : [];
    if (root.querySelectorAll) {
      Array.prototype.push.apply(scopes, root.querySelectorAll(SCOPES));
    }
    scopes.forEach(function (scope) {
      // Yalnızca çocuğu olmayan (yaprak) öğeler — yorum gövdelerine dokunulmaz
      scope.querySelectorAll('*').forEach(function (el) {
        if (el.children.length) return;
        if (el.dataset.trDone === '1') return;
        var t = (el.textContent || '').trim();
        if (t && Object.prototype.hasOwnProperty.call(TR, t)) {
          el.textContent = TR[t];
          el.dataset.trDone = '1';
        }
      });
      // Butonların ve girdilerin görünen metinleri
      scope.querySelectorAll('input[type="submit"], input[type="button"]').forEach(function (el) {
        var v = (el.value || '').trim();
        if (Object.prototype.hasOwnProperty.call(TR, v)) el.value = TR[v];
      });
      scope.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
        var p = (el.placeholder || '').trim();
        if (Object.prototype.hasOwnProperty.call(TR, p)) el.placeholder = TR[p];
      });
    });
  }

  function boot() {
    translateIn(document);

    // Widget geç yüklendiği ve sekme değiştikçe yeniden çizildiği için izliyoruz.
    // Kendi yazdığımız metin de gözlemciyi tetikleyeceğinden, çeviri sırasında
    // gözlemciyi durduruyor ve isteği bir kare geciktiriyoruz; böylece döngü olmuyor.
    var obs = new MutationObserver(schedule);
    var pending = false;

    function run() {
      pending = false;
      obs.disconnect();
      try { translateIn(document); } finally { start(); }
    }

    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(run);
    }

    function start() {
      obs.observe(document.body, { childList: true, subtree: true });
    }

    start();

    // Judge.me bazen tek seferlik geç çizim yapar
    [600, 1500, 3000].forEach(function (ms) { setTimeout(schedule, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
